<template>
  <div class="font-roboto-condensed register-workflow register">
    <div class="mainLogoPosition text-center">
      <img src="@/assets/gregorys_logo.png" class="mb-3" style="width: 200px" />
    </div>
    <div
      class="introduction"
      v-if="
        !registrationCompleted &&
          ($translation('b2b_register_title') !== 'b2b_register_title' ||
            $translation('b2b_register_subtitle') !== 'b2b_register_subtitle')
      "
    >
      <h1>{{ $translation('b2b_register_title') }}</h1>
      <p>{{ $translation('b2b_register_subtitle') }}</p>
    </div>
    <el-row>
      <el-col>
        <p
          :class="{ 'd-none': registrationCompleted }"
          v-html="this.$translation('b2b_register_instructions')"
        ></p>

        <el-form
          ref="RegisterForm"
          :model="RegisterForm"
          :rules="registerRules"
          status-icon
          label-position="top"
          label-width="120px"
          class="register-form mt-3"
          :class="{ 'd-none': registrationCompleted }"
          @validate="validateForm"
        >
          <el-row :gutter="5">
            <el-col :span="12" :xs="24">
              <el-form-item
                prop="first_name"
                :label="this.$translation('b2b_first_name')"
              >
                <el-input
                  v-model="RegisterForm.first_name"
                  :placeholder="this.$translation('b2b_first_name')"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" :xs="24">
              <el-form-item
                prop="last_name"
                :label="this.$translation('b2b_last_name')"
              >
                <el-input
                  v-model="RegisterForm.last_name"
                  :placeholder="this.$translation('b2b_last_name')"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item
            prop="gender"
            :label="this.$translation('b2b_gender_text')"
          >
            <el-select
              v-model="RegisterForm.gender"
              :placeholder="$translation('b2b_gender_text')"
            >
              <el-option
                v-for="item in getGenderList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item
                prop="country_code"
                :label="this.$translation('b2b_country_code')"
              >
                <el-select
                  v-model="RegisterForm.country_code"
                  :placeholder="'+30'"
                  @change="checkMobileValue"
                >
                  <el-option
                    v-for="type in countryCodeList"
                    :key="type.value"
                    :label="type.label"
                    :value="type.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item
                prop="mobile"
                :label="this.$translation('b2b_mobile')"
              >
                <el-input
                  ref="mobile"
                  v-model="RegisterForm.mobile"
                  :placeholder="this.$translation('b2b_mobile')"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item prop="email" :label="this.$translation('b2b_email')">
            <el-input
              v-model="RegisterForm.email"
              :placeholder="this.$translation('b2b_email')"
            ></el-input>
          </el-form-item>
          <el-form-item prop="email" :label="this.$translation('b2b_role')">
            <el-select
              v-model="RegisterForm.role"
              :placeholder="this.$translation('b2b_role')"
              @change="
                validateForm(
                  'store',
                  RegisterForm.role === 'Trainee' ||
                    (RegisterForm.role === 'Staff' &&
                      RegisterForm.store.length > 0)
                );
                validateForm(
                  'job_position',
                  RegisterForm.role === 'Trainee' ||
                    (RegisterForm.role === 'Staff' && RegisterForm.job_position)
                );
                RegisterForm.store = [];
              "
            >
              <el-option
                :label="this.$translation('b2b_type_staff')"
                :value="'Staff'"
              ></el-option>
              <el-option
                :label="this.$translation('b2b_type_trainee')"
                :value="'Trainee'"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="RegisterForm.role === 'Staff'"
            prop="store"
            :label="this.$translation('b2b_stores')"
            placement="bottom"
          >
            <multiselect
              v-if="allStoresGetter.data"
              v-model="RegisterForm.store"
              :options="allStoresGetter.data"
              :placeholder="this.$translation('b2b_select_stores')"
              :close-on-select="false"
              :multiple="true"
              :hide-selected="true"
              :max="5"
              open-direction="bottom"
              track-by="id"
              label="store_name"
              @input="multiselectChange"
            >
              <template slot="maxElements">{{
                $translation('b2b_max_stores_selected')
              }}</template>
              <template slot="caret"
                ><i
                  :class="{ valid: formValidFields.store }"
                  class="multiselect-caret el-select__caret el-input__icon el-icon-arrow-down"
                ></i>
                <i
                  v-if="formValidFields.store"
                  class="multiselect-validateIcon el-input__icon el-input__validateIcon el-icon-circle-check"
                ></i
              ></template>
            </multiselect>
          </el-form-item>
          <el-form-item
            v-if="RegisterForm.role === 'Staff'"
            prop="job_position"
            :label="this.$translation('b2b_job_position')"
          >
            <el-select
              v-model="RegisterForm.job_position"
              :placeholder="this.$translation('b2b_select_job_position')"
            >
              <el-option
                v-for="job_position in allJobPositionsGetter"
                :key="job_position.id"
                :label="job_position.title"
                :value="job_position.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              class="create-account-btn"
              @click="onSubmit"
              :disabled="!isFormValid"
              >{{ this.$translation('b2b_create_account') }}</el-button
            >
            <p class="text-center pointer resetText" @click="$router.push('/')">
              {{ this.$translation('b2b_back_to_login') }}
            </p>
          </el-form-item>
        </el-form>

        <div
          class="thanks-message"
          :class="{ 'd-none': !registrationCompleted }"
        >
          <p>
            {{ this.$translation('b2b_thank_for_register') }}
          </p>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import Multiselect from 'vue-multiselect';
import { SignUpApi } from '@/utils/echoApi';
import { isValidPhoneWithCode } from '@/utils/validate';
import * as RegisterValidators from '@/components/Shared/validators/registerValidators';
export default {
  name: 'RegisterForm',
  components: {
    Multiselect
  },
  data() {
    const validateMobile = (rule, value, callback) => {
      let countryCode = this.RegisterForm.country_code;
      if (value.length === 0) {
        callback(new Error('Mobile is required'));
      } else if (isNaN(value)) {
        callback(new Error('Mobile must be numeric'));
      } else {
        if (countryCode === 30) {
          if (value.length !== 10) {
            callback(new Error('Mobile must have 10 digits'));
          } else if (!value.startsWith('69')) {
            callback(new Error('Mobile must have 69XXXXXXXX format'));
          } else {
            callback();
          }
        } else {
          callback();
        }
      }
    };
    return {
      registrationCompleted: false,
      RegisterForm: {
        first_name: '',
        last_name: '',
        gender: '',
        country_code: 30,
        mobile: '',
        email: '',
        role: 'Staff',
        store: [],
        job_position: ''
      },
      formValidFields: {
        first_name: false,
        last_name: false,
        gender: false,
        mobile: false,
        store: false,
        job_position: false
      },
      registerRules: {
        first_name: [
          {
            required: true,
            message: 'First name is required',
            trigger: 'change'
          }
        ],
        last_name: [
          {
            required: true,
            message: 'Last name is required',
            trigger: 'change'
          }
        ],
        gender: [
          {
            required: true,
            message: 'Gender is required',
            trigger: 'change'
          }
        ],
        country_code: [
          {
            required: true,
            trigger: 'change'
          }
        ],
        mobile: [
          {
            required: true,
            trigger: 'change',
            validator: validateMobile
          }
        ],
        email: [
          {
            required: false,
            trigger: 'change',
            validator: RegisterValidators.validateEmail
          }
        ],
        store: [
          {
            required: true,
            trigger: 'change',
            validator: RegisterValidators.validateStoresSelect
          }
        ],
        job_position: [
          {
            required: true,
            trigger: 'change',
            message: 'You must select a job position'
          }
        ]
      }
    };
  },
  computed: {
    ...mapGetters('data', ['hostname', 'allStoresGetter']),
    ...mapGetters('data', ['hostname', 'allJobPositionsGetter']),
    ...mapState('data', {
      Translations: state => state.Translations
    }),
    isFormValid() {
      for (let field in this.formValidFields) {
        if (!this.formValidFields[field]) return false;
      }

      return true;
    },
    getGenderList() {
      return [
        {
          value: 1,
          label: this.$translation('b2b_gender_male')
        },
        {
          value: 2,
          label: this.$translation('b2b_gender_female')
        },
        {
          value: 3,
          label: this.$translation('b2b_gender_other')
        },
        {
          value: 4,
          label: this.$translation('b2b_gender_no_answer')
        }
      ];
    },
    countryCodeList() {
      return [
        {
          label: '+30',
          value: 30
        },
        {
          label: '+40',
          value: 40
        },
        {
          label: '+49',
          value: 49
        },
        {
          label: '+357',
          value: 357
        }
      ];
    }
  },
  created() {
    this.getAllStores();
    this.getAllJobPositions();
  },
  mounted() {
    document.body.classList = 'register';
  },
  methods: {
    ...mapActions('data', ['getAllStores']),
    ...mapActions('data', ['getAllJobPositions']),
    onSubmit() {
      this.$refs['RegisterForm'].validate(valid => {
        if (valid) {
          this.sendRegisterRequest();
        } else {
          return false;
        }
      });
    },

    sendRegisterRequest() {
      let registerInfo = { ...this.RegisterForm };
      registerInfo.store = registerInfo.store.map(store => store.id);
      this.$http
        .post('https://' + this.hostname + SignUpApi, registerInfo, {
          headers: { Accept: 'application/json' }
        })
        .then(response => {
          if (response.status === 200) {
            this.$message({
              type: response.data.status,
              message: this.$translation(response.data.message)
            });

            this.registrationCompleted = true;
          }
        })
        .catch(error => {
          this.$message({
            type: error.response.data.status,
            message: this.$translation(error.response.data.message)
          });
        });
    },

    multiselectChange(selectedStoresList) {
      this.RegisterForm.store = selectedStoresList;
      this.validateForm('store', this.RegisterForm.store.length > 0);
    },

    validateForm(field, isValid) {
      this.formValidFields[field] = isValid;
    },
    checkMobileValue() {
      let _this = this;
      let oldMobile = _this.RegisterForm.mobile;
      _this.RegisterForm.mobile = '';
      setTimeout(function() {
        _this.RegisterForm.mobile = oldMobile;
        let mobileValid = isValidPhoneWithCode(
          _this.RegisterForm.mobile,
          _this.RegisterForm.country_code
        );
        _this.validateForm('mobile', mobileValid);
      }, 200);
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.register-form {
  .el-input__inner {
    font-weight: 600;
  }
  .el-input__suffix {
    color: #509fec;
  }
}

.introduction {
  text-align: center;

  h1 {
    font-weight: bold;
    font-size: 32px;
    line-height: 32px;
    margin-top: 0;
    margin-bottom: 15px;
  }

  p {
    font-size: 20px;
    width: 80%;
    margin: 0 auto 22px;
  }
}

.register-workflow .create-account-btn {
  width: 100%;
  margin-top: 25px;
  background-color: #00b724 !important;
  padding: 14px 20px;
  font-size: 20px;
  border-radius: 12px;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

.is-disabled.create-account-btn {
  background-color: #a9a9a9 !important;
}

.thanks-message {
  font-size: 18px;
  text-align: center;
  font-weight: 500;
}

.thanks-back-to-log {
  width: 100%;
  margin-bottom: 20px;
}

/* MULTISELECT */
.multiselect__tags {
  background: #f4f4f4;
  border: 0;
  border-radius: 2;
  padding-right: 45px;
}

.multiselect {
  background: #f4f4f4;
  line-height: 16px;
}

.el-form-item--medium .el-form-item__content {
  line-height: 16px;
}

.multiselect__tag {
  font-size: 18px;
  white-space: normal;
  padding-right: 38px;
  background: var(--main-color);
}

.multiselect__tag-icon {
  display: flex;
  align-items: center;
  margin: 0;
  width: fit-content;
  padding: 0 14px;
}

.multiselect__tag-icon:after {
  font-size: 24px;
}

.multiselect__input,
.multiselect__single {
  background-color: #f4f4f4;
}

.multiselect__select {
  transform: rotate(90deg);
  font-size: 12px;
}

.multiselect__select:before {
  border-style: hidden;
  border-width: 0;
  content: '';
}

.multiselect__option--highlight {
  background: var(--main-color);
}

.multiselect-caret {
  position: absolute;
  right: 5px;
  top: -1px;
  color: #9b9ea5;
  font-size: 14px;
  line-height: 36px;
  transition: all 0.3s ease-in-out;
}

.multiselect-caret.valid {
  right: 30px;
}

.multiselect-validateIcon {
  position: absolute;
  right: 5px;
  color: #509fec;
}

.multiselect--active .multiselect-caret {
  transform: rotate(-180deg);
}

.multiselect__tag-icon::after {
  border-radius: 0;
  color: white;
}

.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background: transparent;
}

.multiselect__tag-icon:focus:after,
.multiselect__tag-icon:hover:after {
  color: white;
}

.multiselect__option--highlight:after {
  display: none;
}

@media (max-width: 531px) {
  .register-workflow .create-account-btn {
    padding: 14px 10px;
    font-size: 16px;
  }

  .multiselect__option {
    font-size: 14px;
    white-space: normal;
  }

  .multiselect__tag {
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Register/index.vue